<div class="min-h-screen flex">

  <!-- ══════ Panel izquierdo: Marca (visible solo en lg+) ══════ -->
  <aside class="hidden lg:flex lg:w-[42%] xl:w-2/5 relative overflow-hidden bg-neutral-950 flex-col items-center justify-center">

    <!-- Imagen de fondo -->
    <img
      src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop"
      alt="" aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover opacity-[0.14]"
    />
    <div class="absolute inset-0 bg-linear-to-b from-neutral-950/70 via-transparent to-neutral-950/80"></div>

    <!-- Contenido de marca -->
    <div class="relative z-10 flex flex-col items-center text-center px-12 max-w-70">

      <!-- Logo -->
      <div class="w-18 h-18 rounded-2xl bg-white/8 border border-white/10 flex items-center justify-center mb-8 backdrop-blur-sm">
        <img ngSrc="/images/app-portal-icon.png" width="82" height="42" [alt]="brandLogoAlt" class="w-10.5 h-auto object-contain" priority />
      </div>

      <h1 class="text-3xl font-bold text-white tracking-tight leading-tight mb-3">
        {{ brandName }}
      </h1>
      <p class="text-neutral-400 text-sm leading-relaxed">
        {{ brandTagline }}
      </p>

      <!-- Decorativo -->
      <div class="flex items-center gap-2 mt-10">
        <span class="w-8 h-px bg-white/15"></span>
        <span class="w-1 h-1 rounded-full bg-white/40"></span>
        <span class="w-8 h-px bg-white/15"></span>
      </div>
    </div>
  </aside>

  <!-- ══════ Panel derecho: Formulario ══════ -->
  <main class="flex-1 flex items-center justify-center p-8 sm:p-12 bg-white dark:bg-neutral-950">
    <div class="w-full max-w-85">

      <!-- Logo compacto (móvil y tablet) -->
      <div class="flex lg:hidden justify-center mb-10">
        <div class="w-12 h-12 rounded-xl bg-neutral-900 flex items-center justify-center">
          <img ngSrc="/images/app-portal-icon.png" width="82" height="42" [alt]="brandLogoAlt" class="w-7 h-auto object-contain" priority />
        </div>
      </div>

      <!-- ── Estado: token inválido ── -->
      @if (tokenInvalid()) {
        <div class="flex flex-col gap-6">

          <div class="flex flex-col items-center text-center gap-3 py-4">
            <div class="w-14 h-14 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center">
              <i class="pi pi-times-circle text-red-500 text-2xl"></i>
            </div>
            <div>
              <h2 class="text-xl font-semibold text-neutral-900 dark:text-white tracking-tight">Enlace expirado</h2>
              <p class="text-sm text-neutral-500 dark:text-neutral-400 mt-1">
                El enlace de recuperación no es válido o ha expirado.<br />Solicita uno nuevo desde el inicio de sesión.
              </p>
            </div>
          </div>

          <p-button
            type="button" label="Volver al inicio de sesión" icon="pi pi-arrow-left"
            (onClick)="goToLogin()"
            [fluid]="true" severity="contrast"
          />
        </div>
      }

      <!-- ── Estado: formulario válido ── -->
      @if (!tokenInvalid()) {

        <!-- Cabecera -->
        <div class="mb-7">
          <h2 class="text-xl font-semibold text-neutral-900 dark:text-white tracking-tight">Nueva contraseña</h2>
          <p class="text-sm text-neutral-500 dark:text-neutral-400 mt-1">Crea una contraseña segura para tu cuenta</p>
        </div>

        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="space-y-4">

          <!-- Campo: Nueva contraseña -->
          <div class="flex flex-col gap-1.5">
            <label for="newPassword" class="text-sm font-medium text-neutral-700 dark:text-neutral-300">Nueva contraseña</label>
            <p-password
              id="newPassword" formControlName="newPassword"
              autocomplete="new-password" placeholder="Mínimo 8 caracteres"
              [feedback]="true" [toggleMask]="true"
              class="w-full" inputStyleClass="w-full"
              promptLabel="Ingresa una contraseña"
              weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
            />
            @if (newPassword.invalid && (newPassword.dirty || newPassword.touched)) {
              <small class="text-red-500 text-xs flex items-center gap-1">
                <i class="pi pi-exclamation-circle"></i>
                Requisito mínimo no cumplido
              </small>
            }
          </div>

          <!-- Campo: Confirmar contraseña -->
          <div class="flex flex-col gap-1.5">
            <label for="confirmPassword" class="text-sm font-medium text-neutral-700 dark:text-neutral-300">Confirmar contraseña</label>
            <p-password
              id="confirmPassword" formControlName="confirmPassword"
              autocomplete="new-password" placeholder="Repite la contraseña"
              [feedback]="false" [toggleMask]="true"
              class="w-full" inputStyleClass="w-full"
            />
            @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) {
              <small class="text-red-500 text-xs flex items-center gap-1">
                <i class="pi pi-exclamation-circle"></i>
                Confirma tu contraseña
              </small>
            }
            @if (resetPasswordForm.hasError('passwordMismatch') && confirmPassword.touched) {
              <small class="text-red-500 text-xs flex items-center gap-1">
                <i class="pi pi-times-circle"></i>
                Las contraseñas no coinciden
              </small>
            }
          </div>

          <!-- Botón principal -->
          <div class="pt-1">
            <p-button
              type="submit" label="Cambiar contraseña" icon="pi pi-check" iconPos="right"
              [loading]="isSubmitting()" [disabled]="resetPasswordForm.invalid"
              [fluid]="true" severity="contrast"
            />
          </div>

          <!-- Cancelar -->
          <p-button
            type="button" label="Cancelar"
            (onClick)="goToLogin()"
            [fluid]="true" variant="text"
            class="text-neutral-600 hover:text-neutral-900"
          />

        </form>
      }

      <!-- Pie -->
      <p class="text-center text-[11px] text-neutral-400 dark:text-neutral-500 mt-10">
        {{ brandFooterLine }}
      </p>

    </div>
  </main>

</div>
